<template>
  <layout-header></layout-header>
  <breadcrumb-index :title="title" :text="text" :text1="text1" />

  <div class="page-wrapper subscription">
    <pricingcontent />

    <pages-footer></pages-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Pricing",
      text: "Home",
      text1: "Pricing",
    };
  },
};
</script>
